{
  "About": "Circa",
  "Accept": "Accettare",
  "Accept partner orders automatically": "Accettare automaticamente gli ordini dei partner",
  "Actions": "Azioni",
  "ActivitiesHistory": "Attività Storia",
  "Activity history": "Storia dell'Attività",
  "Add": "Aggiungere",
  "Add Action": "Aggiungi azione",
  "Add Rating": "Aggiungi valutazione",
  "Add another": "Aggiungi un altro",
  "Add items first": "Aggiungere prima gli articoli",
  "Add new": "Aggiungi nuovo",
  "Add workflow": "Aggiungi flusso di lavoro",
  "Address": "Indirizzo",
  "Administration": "Amministrazione",
  "Api Keys Management": "Gestione delle chiavi API",
  "Api_keys_description": "I token API consentono di interagire con la nostra API REST e di collegare applicazioni come Control Center o neoCatalog con Inèdit Connect. Tenere presente che la nuova chiave generata sarà visualizzata solo una volta, quindi assicurarsi di copiarla e salvarla in un luogo sicuro.",
  "Application Preferences": "Preferenze dell'applicazione",
  "Archive": "Archivio",
  "Are you sure you want to delete the selected Users": "Siete sicuri di voler eliminare l'utente selezionato?",
  "Are you sure you want to exit without saving": "Siete sicuri di voler uscire senza salvare?",
  "As the order has no items it will be deleted": "Poiché l'ordine non ha articoli, verrà cancellato.",
  "Cancel": "Annullamento",
  "Changes not saved": "Le modifiche non sono state salvate",
  "Choose a material first": "Scegliere prima un materiale",
  "City": "Città",
  "Code": "Codice",
  "Color": "Colore",
  "Columns": "Colonne",
  "Comments": "Commenti",
  "Company": "Azienda",
  "Company Address": "Indirizzo dell'azienda",
  "Company alias": "Alias aziendale",
  "Company information saved": "Informazioni sulla società salvate",
  "Company name": "Nome della società",
  "Company street": "Via dell'azienda",
  "Confirm": "Confermare",
  "Continue": "Continua",
  "Continue without saving": "Continuare senza salvare",
  "Copy": "Copia",
  "Country": "Paese",
  "Create": "Creare",
  "Create today!": "Create oggi!",
  "Creation Date": "Data di creazione",
  "Customer": "Cliente",
  "Date": "Data",
  "Date Created": "Data di creazione",
  "Default Scheme": "Schema predefinito",
  "Default Stage": "Fase predefinita",
  "Default workflow": "Flusso di lavoro predefinito",
  "Default workflow stage": "Fase del flusso di lavoro predefinita",
  "Delete": "Cancellare",
  "Delete Items": "Eliminare gli elementi",
  "Delete Workflow": "Eliminazione del flusso di lavoro",
  "Delivery Date": "Data di consegna",
  "Description": "Descrizione",
  "Designer Brand": "Marchio del designer",
  "Designing": "Progettazione",
  "Discard changes": "Scartare le modifiche",
  "Discover": "Scoprire",
  "Do not have an account?": "Non avete un account?",
  "Do you want to delete this items This action cannot be undone": "Si desidera eliminare questo elemento? Questa azione non può essere annullata|Vuoi cancellare questi elementi? Questa azione non può essere annullata",
  "Do you want to delete this order items": "Vuoi cancellare questa voce d'ordine|Vuoi cancellare questa voce d'ordine {count}?",
  "Do you want to delete this order?": "Vuole cancellare questo ordine?",
  "Do you want to delete this response": "Vuoi cancellare questa risposta?",
  "Do you want to delete this stage": "Volete cancellare questa tappa?",
  "Do you want to delete this token?": "Si vuole cancellare questo token?",
  "Do you want to delete this workflow Changes cant be undone": "Si desidera eliminare questo flusso di lavoro? Le modifiche non possono essere annullate.",
  "Do you want to split this item? A new order with _split suffix will be created": "Vuoi dividere questo articolo? Verrà creato un nuovo ordine con suffisso _split|Vuoi dividere questo articolo? Verrà creato un nuovo ordine con suffisso _split",
  "Download": "Scaricare",
  "Drag and drop files here to upload": "Trascinate i file qui per caricarli.",
  "Drag and drop orders here to send them to the printer mill": "Trascinate qui gli ordini per inviarli al mulino della stampante.",
  "Edit": "Modifica",
  "Edit Material": "Modifica del materiale",
  "Edit MaterialType": "Modifica del tipo di materiale",
  "Edit review": "Modifica della recensione",
  "Email": "Email",
  "Error creating stage": "Errore nella creazione della fase",
  "Error deleting workflow": "Errore nell'eliminazione del flusso di lavoro",
  "Error saving workflow": "Errore nel salvataggio del flusso di lavoro",
  "Error updating stage": "Fase di aggiornamento degli errori",
  "Error while archiving order item": "Errore durante l'archiviazione dell'ordine",
  "Error while saving rating": "Errore durante il salvataggio della recensione",
  "Failed to save company information": "Impossibile salvare le informazioni aziendali",
  "Features": "Caratteristiche",
  "File": "File",
  "a new file": "un nuovo file",
  "File History": "Storia del file",
  "Fix the errors in the form before continuing": "Correggere gli errori nel modulo prima di continuare",
  "Do you want to delete this item? This action cannot be undone.": "Vuoi eliminare questo elemento? Questa azione non può essere annullata.",
  "Generate": "Generare",
  "Global Settings": "Impostazioni globali",
  "Go to login page": "Vai alla pagina di accesso",
  "Hello World!": "Ciao Word!",
  "Hidden": "Nascosto",
  "Home": "Home",
  "Incoming Orders": "Ordini in arrivo",
  "It will we displayed publicly": "Verrà esposto pubblicamente",
  "Items": "Articolo|Articoli",
  "JoinNow": "Iscriviti ora!",
  "Last Used": "Ultimo usato",
  "Length": "Lunghezza",
  "Licenses": "Licenze",
  "Loading material types data": {
    " Please wait": "Caricamento dei dati dei tipi di materiale. Attendere prego"
  },
  "Loading materialTypes data_Please wait": "Caricamento dei dati dei materiali. Attendere prego",
  "Loading printers data": {
    " Please wait": "Caricamento dei dati delle stampanti. Attendere prego"
  },
  "Log In": "Accedi",
  "Login": "Accesso",
  "Manage MaterialTypes": "Gestire i tipi di materiale",
  "Manage Workers": "Gestire i lavoratori",
  "Manage material types": "Gestire i tipi di materiale",
  "Material Type": "Tipo di materiale",
  "Material Types": "Tipi di materiale",
  "Material deleted successfully": "Materiale cancellato con successo",
  "MaterialType": "Materiale",
  "MaterialType created successfully": "Tipo di materiale creato con successo",
  "MaterialType deleted successfully": "Tipo di materiale cancellato con successo",
  "MaterialType updated successfully": "Tipo di materiale aggiornato con successo",
  "MaterialTypes": "Tipi di materiale",
  "MaterialTypes Management": "Gestione dei tipi di materiale",
  "Materials": "I materiali",
  "Max": "A",
  "Measure": "Misura",
  "Min": "Da",
  "Move to stage": "Passare al palcoscenico",
  "Name": "Nome",
  "New Comment:": "Nuovo commento:",
  "New Material": "Nuovo materiale",
  "New Material Type": "Nuovo Tipo di materiale",
  "New MaterialType": "Nuovo tipo di materiale",
  "New Order": "Nuovo Ordine",
  "New Token": "Nuovo gettone",
  "New print Order": "Nuovo ordine di stampa",
  "New token": "Nuovo gettone",
  "No": "No",
  "No actions selected": {
    " Add actions with button below": "Non sono state selezionate azioni. Aggiungete le azioni con il pulsante sottostante."
  },
  "No comments yet": "Non ci sono ancora commenti",
  "No image file": "Nessun file di articoli",
  "No material types found": "Nessun tipo di materiale trovato",
  "No materials found": "Nessun materiale trovato",
  "No partner": "Nessun partner",
  "No printers found": "Nessuna stampante trovata",
  "Number": "Numero",
  "Order": "Ordine",
  "Order Code": "Codice d'ordine",
  "Order Name": "Nome dell'ordine",
  "Object Size": "Dimensione dell'oggetto",
  "Order created successfully": "Ordine creato con successo",
  "Order deleted successfully": "Ordine cancellato con successo",
  "Order edited successfully": "Ordine modificato con successo",
  "Order has been completed": "L'ordine è stato completato",
  "Order has been rejected": "L'ordine è stato respinto",
  "Order has no items": "L'ordine non ha articoli",
  "Order is being worked on": "L'ordine è in fase di lavorazione",
  "Order item archived successfully": "Articolo dell'ordine archiviato con successo",
  "Order item has been archived": "L'ordine è stato archiviato",
  "Order items archived successfully": "Ordini archiviati con successo",
  "Order items deleted successfully": "Voci dell'ordine cancellate con successo",
  "Order received to be reviewed and accepted or rejected": "Ordine ricevuto per essere esaminato e accettato o rifiutato",
  "Order that has been received": "Ordine ricevuto",
  "Orders": "Ordini",
  "Partner preferences saved successfully": "Preferenze del partner salvate con successo",
  "Partners": "\nPartner",
  "Password": "Password",
  "password": "Password",
  "Pending": "In attesa",
  "Pending invitations": "Inviti in sospeso",
  "Phone number": "Numero di telefono",
  "Pieces": "Pezzi",
  "Please enter a reason for rejection": "Inserire un motivo per il rifiuto",
  "Please fill in all fields": "Compilare tutti i campi",
  "Please fill in all required fields": "Compilare tutti i campi obbligatori",
  "Please save or cancel the changes before adding another stage": "Salvare o annullare le modifiche prima di aggiungere un'altra tappa.",
  "Please save or cancel the changes before editing another stage": "Salvare o annullare le modifiche prima di modificare un'altra fase.",
  "Port": "Porto",
  "Preferences": "Preferenze",
  "Price": "Prezzo",
  "Printer Mill": "Stamperia",
  "Printer deleted successfully": "La stampante è stata eliminata con successo",
  "Printers": "Stampanti",
  "Printing": "Stampa",
  "Product": "Prodotto",
  "Publish": "Pubblicare",
  "Quantity": "Quantità",
  "Rating saved successfully": "Revisione salvata con successo",
  "Reject": "Rifiuto",
  "Reject order": "Rifiuto dell'ordine",
  "Remember me": "Ricordati di me",
  "Replace file": "Sostituire il file",
  "Reply": {
    "": ""
  },
  "Reset your password": "Reimpostare la password",
  "Role": "Ruolo",
  "Roles": "Ruoli",
  "Roles & Permissions": "Ruoli e permessi",
  "Save": "Risparmiare",
  "Save changes": "Salva le modifiche",
  "Search": "Ricerca",
  "Search by code": "Ricerca per codice",
  "Search by description": "Ricerca per descrizione",
  "Search by file": "Ricerca per file",
  "Search by name": "Ricerca per nome",
  "Select Columns": "Selezionare le colonne",
  "Select Country": "Selezionare Paese",
  "Select Material": "Selezionare materiale",
  "Select MaterialType": "Selezionare tipo di materiale",
  "Select Role": "Selezionare ruolo",
  "Select Type": "Selezionare tipo",
  "Select Unit": "Selezionare'unità",
  "Select material type": "Selezionare tipo di materiale",
  "Select actions": "Selezionare le azioni",
  "Select all": "Seleziona tutti",
  "Select action": "Selezionare'azione",
  "Select or drag and drop in the box below the new file that you want to upload": "Selezionare o trascinare nel riquadro sottostante il nuovo file che si desidera caricare.",
  "Select units type": "Selezionareità",
  "Send": "Inviare",
  "Send to partner": "Inviare al partner",
  "Some items failed to send": "Alcuni elementi non sono stati inviati: {successful}/{total} riusciti",
  "Order items sent to partner": "Elementi inviati al partner: {successful}/{total} riusciti",
  "Failed to send order items to partner": "Impossibile inviare elementi al partner",
  "Services": "Servizi",
  "Show Archived": "Mostra archiviatos",
  "SignUp": "Iscriviti",
  "Skip this step": {
    " I will add workers later": "Saltare questo passaggio. Aggiungerò i lavoratori in seguito"
  },
  "Sku": "SKU",
  "Split to new order": "Dividere per un nuovo ordine",
  "Stage created successfully": "Stadio creato con successo",
  "Stage updated successfully": "La fase è stata aggiornata con successo",
  "State": "Stato",
  "Status": "Stato",
  "Stock Available": "Stock disponibile",
  "Street": "Via",
  "Surname": "Cognome",
  "There are no items for this order please add new items with the button below": "Non ci sono articoli per questo ordine, si prega di aggiungere nuovi articoli con il pulsante qui sotto",
  "There should be at least one Admin user": "Deve esserci almeno un utente amministratore",
  "There was an error creating the MaterialType": "Si è verificato un errore nella creazione del tipo di materiale",
  "There was an error deleting order": "Si è verificato un errore nell'eliminazione dell'ordine",
  "There was an error deleting the MaterialType": "Si è verificato un errore nell'eliminazione del tipo di materiale",
  "There was an error deleting the Printer": "Si è verificato un errore nell'eliminazione della stampante",
  "There was an error moving the item": "Si è verificato un errore nello spostamento dell'elemento",
  "There was an error moving the order": "Si è verificato un errore nello spostamento dell'ordine",
  "There was an error updating the Material": "Si è verificato un errore nell'aggiornamento del Materiale",
  "There was an error updating the MaterialType": "Si è verificato un errore nell'aggiornamento del tipo di materiale",
  "This is a test": "Questo è un test",
  "Type": "Tipo",
  "URL": "URL",
  "UUID": "UUID",
  "Unit": "Unità",
  "Units": "Unità",
  "Units of measure": "Unità di misura",
  "Unsaved changes": "Modifiche non salvate",
  "User email must be unique": "L'email dell'utente deve essere unica",
  "Users": "Utenti",
  "Users deleted successfully": "Utente cancellato con successo|{conteggio} utenti cancellati con successo",
  "Value is not a valid email address": "Il valore non è un indirizzo e-mail valido",
  "Value is required": "Il valore è richiesto",
  "View": "Vista",
  "Weak": "Debole",
  "Welcome Back": "Bentornato",
  "Workflow": "Flusso di lavoro",
  "Workflow Stages": "Fasi del flusso di lavoro",
  "Workflow deleted": "Flusso di lavoro eliminato",
  "Workflow saved": "Flusso di lavoro salvato",
  "Workflows": "Flussi di lavoro",
  "Workstation": "Postazione di lavoro",
  "Write a review": "Scrivi una recensione",
  "Yes": "Sì",
  "Your name": "Il vostro nome",
  "Zip": "Zip",
  "Zip Code": "Codice postale",
  "accept_partnership": {
    "description": "Ora siete partner di {azienda}.",
    "title": "Congratulazioni!",
    "__i18n_ally_root__": {
      "description": "Ora sei partner con {company}."
    }
  },
  "are-you-sure-delete-printer": "Siete sicuri di voler eliminare questa stampante?",
  "cant delete workflow with orders": "Non è possibile eliminare il flusso di lavoro con gli ordini",
  "centimeters": "Centimetri",
  "company description placeholder": "Raccontateci qualcosa della vostra azienda, in modo che i vostri partner possano conoscervi meglio. Ad esempio: Quali prodotti o servizi offre la vostra azienda? In che modo la vostra azienda si distingue dalla concorrenza?",
  "contactUs": "Contatto",
  "copies": "Copie",
  "created this order item": "{name} ha creato questa voce d'ordine",
  "created a print job for this order item": "{name} ha creato un lavoro di stampa per questa voce d'ordine",
  "email": "e-mail",
  "finish_signup": {
    "description": "Manca solo un passo per creare il vostro account!",
    "title": "Quasi finito!"
  },
  "first": {
    "agree": "Continuando, l'utente accetta le nostre {terms} e dichiara di aver letto la nostra {data-use-policy}, compreso {cookies-use}.",
    "description": "Verrà utilizzato come amministratore della società.",
    "title": "Per prima cosa, comunicateci il vostro indirizzo e-mail e la vostra password"
  },
  "forgot_password_description": "Inserisci il tuo indirizzo e-mail qui sotto, se è un indirizzo valido ti invieremo un'e-mail con le istruzioni per reimpostare la tua password.",
  "go back to": "torna a {nome}",
  "in": "in",
  "inches": "Pollici",
  "ineditLong": "Inèdit Software SL",
  "items_deleted_successfully": "Voce cancellata con successo|{conteggio} voci cancellate con successo",
  "loading-customers-data-please-wait": "Caricamento dei dati dei clienti. Attendere prego.",
  "mailPlaceholder": "Ad esempio, nome{'@'}azienda.com",
  "mail_not_received": "Non avete ricevuto l'e-mail? Controllate la cartella spam o",
  "mail_sent_description": "Abbiamo inviato un'e-mail al vostro indirizzo di posta elettronica con le istruzioni per reimpostare la password.",
  "medium": "Medio",
  "message": "ciao i18n !!!",
  "meters": "Metri",
  "name": "nome",
  "no-customers-found": "Nessun cliente trovato",
  "no_delete_self": "Non è possibile cancellare se stessi",
  "pagination-text": "Mostra {ultima} di {totalRecords} | Mostra da {prima} a {ultima} voce di {totalRecords}",
  "password_reset": {
    "description": "Inserire la nuova password qui sotto",
    "title": "Nuova password"
  },
  "pick-a-password": "Scegliere una password",
  "pixels": "Pixel",
  "printer deleted successfully": "La stampante è stata eliminata con successo",
  "ratings": "recensione|recensioni",
  "reset_ok": {
    "description": "Ora è possibile accedere con la nuova password.",
    "title": "Password ripristinata"
  },
  "reset_password_description": "Inserite l'e-mail associata al vostro account e vi invieremo un'e-mail con un link e le istruzioni per reimpostare la password.",
  "second": {
    "title": "Ora, ci dica il nome della sua azienda",
    "description": "Questo sarà il nome utilizzato per connettersi con i partner."
  },
  "start": {
    "title1": "Il modo più semplice per mettere in contatto i marchi di design con i centri di stampa",
    "title2": "Inèdit Connect è il modo più semplice, veloce e affidabile per ricevere, gestire e distribuire gli ordini di stampa ai clienti.",
    "description": "Una {0} progettata per colmare il divario {1} o marchi e {2}.",
    "description2": "Questa piattaforma mira a rivoluzionare il modo in cui ci avviciniamo alla produzione, fornendo un {0} per la {1}."
  },
  "strong": "Forte",
  "suggestions": "Suggerimenti",
  "terms": "Termini",
  "third": {
    "title": "Infine, aggiungi alcuni lavoratori della tua azienda",
    "description": "Potranno vedere e gestire il flusso di lavoro di stampa della tua azienda."
  },
  "otp": {
    "title": "Verifica la tua email",
    "description": "Abbiamo inviato un codice di verifica a",
    "verify": "Verifica",
    "resend": "Reinvia codice"
  },
  "to": "a",
  "token_warning": "Questo token verrà visualizzato una sola volta. Copiatelo e conservatelo in un luogo sicuro.",
  "validations": {
    "alphaNum": "Il valore può contenere solo lettere e numeri.",
    "maxLength": "Il campo {property} deve avere una lunghezza massima di {max}.",
    "minLength": "Il campo {property} deve avere una lunghezza minima di {min}.",
    "required": "Il campo {property} è obbligatorio."
  },
  "workflowStages_description": "È possibile personalizzare facilmente i flussi di lavoro aggiungendo nuove fasi al flusso di lavoro. È sufficiente inserire il nome, la descrizione e l'ordine di ogni fase. Ciò garantisce flessibilità e adattabilità, consentendo di creare flussi di lavoro adatti alle vostre esigenze specifiche e di migliorare la produttività.",
  "you-have-unsaved-changes-do-you-want-to-save-or-continue-losing-your-changes": "Le modifiche non sono state salvate. Volete salvare o continuare a perdere le modifiche?",
  "Something went wrong Please try again later": "Qualcosa è andato storto. Riprovare più tardi.",
  "couldnt-connect-to-the-server-please-try-again-later": "Impossibile connettersi al server. Riprovare più tardi.",
  "you-are-not-connected-to-the-internet-verify-your-connection-and-then-try-again": "Non si è connessi a Internet. Verificare la connessione e riprovare.",
  "something-went-wrong-please-try-again-later": "Qualcosa è andato storto. Riprovare più tardi.",
  "Write your comments here": "Scrivete qui i vostri commenti...",
  "do-you-want-to-delete-this-company": "Volete cancellare questa azienda? Tutti i dati, compresi gli ordini, gli utenti, i flussi di lavoro, ecc. saranno cancellati.",
  "we-have-sent-you-an-email-with-instructions-to-delete-your-company-and-all-your-data": "Vi abbiamo inviato un'e-mail con le istruzioni per cancellare la vostra azienda e tutti i dati.",
  "Check your email": "Controllare la posta elettronica",
  "Ok": "Ok",
  "company-successfully-deleted": "Azienda cancellata con successo",
  "Logout": "Disconnessione",
  "At least one lowercase": "Almeno una minuscola",
  "At least one uppercase": "Almeno una maiuscola",
  "At least one numeric": "Almeno un dato numerico",
  "Minimum 8 characters": "Minimo 8 caratteri",
  "Email already taken": "Email già presa",
  "Email is required": "L'e-mail è necessaria",
  "Email is not valid": "L'e-mail non è valida",
  "now-tell-us-your-company-name": "Ci dica il nome della sua azienda",
  "This will be the name used to connect with partners": "Questo sarà il nome utilizzato per connettersi con i partner.",
  "settings": "Impostazioni",
  "Tell us how was the experience with your partner": "Raccontaci com'è stata l'esperienza con il tuo partner",
  "Partners discovery": "Scoperta dei partner",
  "Discover new partners": "Scoprire nuovi partner",
  "select-services": "Seleziona i servizi",
  "Showing X results": "Mostra 0 risultati|Mostra 1 risultato|Mostra {count} risultati",
  "Rating": "Valutazione",
  "Partners since": "Partner dal",
  "replied": "risposto",
  "generic-column-with-no-special-dividers": "Generico: Colonna senza divisori speciali",
  "partners-column-with-sections-for-each-one-of-the-companys-partners": "Partner: Colonna con sezioni per ciascuno dei partner dell'azienda.",
  "printers-column-with-sections-for-each-one-of-the-companys-printers": "Stampanti: Colonna con sezioni per ciascuna delle stampanti dell'azienda.",
  "Drag and drop a file here to upload": "Trascinare e rilasciare un file qui per caricarlo",
  "material-type-is-required": "Il tipo di materiale è obbligatorio.",
  "name-is-required": "Il nome è obbligatorio.",
  "do-you-want-delete-this-partnership": "Volete cancellare questa partnership?",
  "submit": "Invia",
  "please-enter-the-email-address-of-one-of-the-allowed-super-admins-we-will-send-you-an-email-with-instructions-on-how-to-access": "Inserire l'indirizzo e-mail di uno dei superamministratori autorizzati. Vi invieremo un'e-mail con le istruzioni per l'accesso.",
  "email-sent": "Email inviata",
  "error-sending-email": "Errore nell'invio dell'e-mail",
  "There was an error verifying the access token": "Si è verificato un errore nella verifica del token di accesso.",
  "Only alphanumeric characters are allowed": "Sono ammessi solo caratteri alfanumerici",
  "loading": "Caricando...",
  "alias": "Alias",
  "created": "Creato",
  "Alias": "Alias",
  "Icon": "Icona",
  "Add new service": "Aggiungere nuovo servizio",
  "Services saved successfully": "Servizi salvati con successo",
  "There was an error saving the services": "Si è verificato un errore nel salvataggio dei servizi",
  "Error rejecting invitation": "Errore nel rifiutare l'invito",
  "Error accepting invitation": "Errore nell'accettazione dell'invito",
  "You are not authorized to perform this action": "Non siete autorizzati a eseguire questa azione",
  "There was an error creating the Order": "Si è verificato un errore nella creazione dell'ordine",
  "There was an error downloading the PDF": "Si è verificato un errore nel download del PDF",
  "Partnership rejected successfully": "Richiesta di partnership respinta con successo",
  "Search by units": "Cerca per unità",
  "Are you sure you want to delete this service": "Siete sicuri di voler eliminare questo servizio",
  "Delete service": "Cancellare il servizio",
  "Do you want to archive this order items": "Vuoi archiviare questo articolo?|Vuoi archiviare questi articoli?",
  "no-partners-column": "Per inviare un ordine a un partner è necessario creare prima una colonna di \"tipo partner\".",
  "error-uploading-file": "Errore nel caricamento del file",
  "file-uploaded-successfully": "File caricato con successo",
  "Company ratings": "Valutazioni aziendali",
  "Error while saving partner preferences": "Errore durante il salvataggio delle preferenze del partner",
  "Private Comment": "Commento privato",
  "Public comment": "Commento del pubblico",
  "public-comment-tooltip": "Se questo elemento viene condiviso con un partner, questo potrà vedere i commenti pubblici.",
  "Accept partnership": "Accettare la partnership",
  "Reject partnership": "Rifiutare la partnership",
  "Schemes for": "Schemi per",
  "Schemes": "Schemi",
  "Active": "Attivo",
  "Public": "Pubblico",
  "Email not allowed": "Email non consentite",
  "Scheme files": "File di schema",
  "MaterialType with this name already exists": "Il tipo di materiale con questo nome esiste già",
  "Comment deleted successfully": "Commento cancellato con successo",
  "There was an error deleting the comment": "Si è verificato un errore nell'eliminazione del commento",
  "There was an error editing the": "Si è verificato un errore nella modifica del ",
  "edited_successfully": " modificato successivamente",
  "comment": "commentario",
  "Comment": "Commentario",
  "Reset to default": "Ripristino delle impostazioni predefinite",
  "do-you-want-to-block-this-partnership": "Vuoi bloccare questo partner?",
  "Block": "Bloccare",
  "Unblock": "Sbloccare",
  "material-edited-successfully": "Materiale editato con successo",
  "material-updated-successfully": "Materiale aggiornato correttamente",
  "there-was-an-error-updating-the-material": "Si è verificato un errore durante l'aggiornamento del materiale",
  "are-you-sure-you-want-to-delete-this-company": "È sicuro di voler cancellare questa azienda?",
  "to-confirm-please-write-delete-on-the-box-below": "Per confermare, scrivere DELETE nel riquadro sottostante",
  "Statistics": "Statistiche",
  "Edited at": "In redazione a",
  "Expired": "Scaduto",
  "A company already exists with this name": "Esiste già un'azienda con questo nome",
  "Analytics": "Analisi",
  "today": "Oggi",
  "this-month": "Questo mese",
  "last-month": "Ultimo mese",
  "this-quarter": "Questo trimestre",
  "Meters": "Metri",
  "Total": "Totale",
  "By date": "Per Data",
  "order-items-by-material-type": "Items per tipo di materiale",
  "hello": "Ciao",
  "last-30-days": "Ultimi 30 giorni",
  "last-3-months": "Ultimi 3 mesi",
  "this-year": "Quest'anno",
  "last-365-days": "Ultimi 365 giorni",
  "forgot-password": "Hai dimenticato la password?",
  "cutting": "Taglio",
  "accepted": "Accettato",
  "idle": "Inattivo",
  "Idle": "Inattivo",
  "In queue": "In coda",
  "Finished": "Finito",
  "order-items-by-customer": "Articoli per partner",
  "order-items-by-workflow-stage": "Elementi per fase",
  "Inches": "Pollici",
  "Centimeters": "Centimetri",
  "Copies": "Copie",
  "select-status": "Selezionare lo stato",
  "No statuses found": "Nessuno stato trovato",
  "x-items-selected": "{count} elementi selezionati",
  "File Name": "Nome del file",
  "User": "Utente",
  "Manager": "Gerente",
  "Admin": "Admin\n",
  "Guest": "Ospite",
  "order-items-by-status": "Items per stato",
  "send-email-to-owner": "Invia un'e-mail al proprietario",
  "send-email-to-items-owner": "Inviare un'e-mail al proprietario dell'articolo",
  "Generic": "Generico",
  "EDIT": "EDIT",
  "VIEW": "VISTA",
  "CREATE": "CREARE",
  "DELETE": "CANCELLARE",
  "Companies": "Aziende",
  "Permissions": "Permessi",
  "Prices": "Prezzi",
  "partner": "Partner",
  "Material": "Materiale",
  "Force touch displays accessibility": "Forza l'accessibilità per i touch screen",
  "company-info": "Informazioni sull'azienda",
  "company-name-preferences": "preferenze di {name}",
  "download-csv": "Scarica CSV",
  "cant-delete-item-because-it-has-been-sent-to-a-partner": "Non è possibile eliminare l'elemento perché è stato inviato a un partner",
  "there-was-an-error-deleting-the-item": "Si è verificato un errore nell'eliminazione dell'elemento",
  "select-a-workflow": "Seleziona un flusso di lavoro",
  "TShirt": "Maglietta",
  "Linen": "Lino",
  "Cotton": "Cotone",
  "Tulle": "Tulle",
  "TShirt Red": "Maglietta rossa",
  "Silk": "Seta",
  "items-by-company": "Articoli per azienda",
  "users-by-company": "Utenti per Azienda",
  "x-columns-selected": "{count} colonne selezionate",
  "Order items": "Articoli",
  "upcoming-due": "Scadenza imminente o scaduta",
  "Filter by": "Filtrare per",
  "Dashboard": "Cruscotto",
  "Width": "Larghezza",
  "Not specified": "Non specificato",
  "Feet": "Piedi",
  "Yards": "Cantieri",
  "material-width-is-required": "Le unità sono richieste",
  "units-required": "Le unità sono richieste",
  "Close": "Chiudere",
  "All": "Tutti",
  "All orders": "Tutti",
  "All order items": "Tutti",
  "Yesterday": "Ieri",
  "last-7-days": "Ultimi 7 giorni",
  "quantity-cant-be-0": "La quantità non può essere 0",
  "rejected": "Rifiutato",
  "no-incoming-items-found": "Nessun articolo in arrivo trovato",
  "Unstarted": "Non avviato",
  "Started": "Avviato",
  "Done": "Fatto",
  "Undefined": "Non definito",
  "Archived": "Archiviato",
  "Invite": "Invito",
  "Starts with": "Inizia con",
  "Contains": "Contiene",
  "Not contains": "Non contiene",
  "Ends with": "Termina con",
  "Equals": "Pari",
  "Not equals": "Non uguale",
  "No Filter": "Nessun filtro",
  "Less than": "Meno di",
  "Less than or equal to": "Inferiore o uguale a",
  "Greater than": "Maggiore di",
  "Greater than or equal to": "Maggiore o uguale a",
  "Date is": "La data è",
  "Date is not": "La data non è",
  "Date is before": "La data è precedente a",
  "Date is after": "La data è successiva a",
  "Clear": "Cancellare",
  "Apply": "Applicare",
  "Match All": "Abbinamenti Tutti",
  "Match Any": "Corrisponde a qualsiasi",
  "Blocked": "Bloccato",
  "Manage ink types": "Gestisci i tipi di inchiostro",
  "default-workflow-stage-for-incoming-orders-must-be-a-generic-stage": "La fase predefinita per gli ordini in arrivo deve essere una fase generica.",
  "a-stage-that-is-set-as-default-of-a-workflow-can-only-be-generic": "Una fase impostata come predefinita di un flusso di lavoro può essere solo generica.",
  "a-stage-that-is-set-as-default-from-partner-preferences-can-only-be-generic": "Una tappa impostata come predefinita dalle preferenze del partner può essere solo generica.",
  "Stage deleted successfully": "Fase cancellata con successo",
  "Choose destinataries": "Scegliere i destinatari",
  "send-email-to-address": "Inviare l'e-mail ai destinatari",
  "Send an email to any email address specified": "Invia un'e-mail a qualsiasi indirizzo di posta elettronica specificato",
  "there-was-an-error-creating-the-user": "Si è verificato un errore nella creazione dell'utente",
  "User already exists with": "L'utente esiste già con",
  "are-you-sure-delete-ink": "Siete sicuri di voler eliminare questo inchiostro?|Siete sicuri di voler eliminare questi inchiostri?",
  "No ink types found": "Nessun tipo di inchiostro trovato",
  "InkType deleted successfully": "Tipo di inchiostro eliminato correttamente",
  "There was an error deleting the InkType": "Si è verificato un errore durante l'eliminazione del tipo di inchiostro",
  "New Ink Type": "Nuovo tipo di inchiostro",
  "InkType created successfully": "Tipo di inchiostro creato correttamente",
  "There was an error creating the InkType": "Si è verificato un errore durante la creazione del tipo di inchiostro",
  "Search by ink types": "Cerca per tipi di inchiostro",
  "Select inks type": "Seleziona il tipo di inchiostri",
  "InkTypes": "Tipi di inchiostro",
  "permissions-saved": "Autorizzazioni salvate",
  "error-saving-permissions": "Errore nel salvataggio delle autorizzazioni",
  "you-dont-have-permission-to-perform-this-action": "Non si ha il permesso di eseguire questa azione",
  "View/Edit": "Visualizza/Modifica",
  "length-units": "Unità di lunghezza",
  "items": "articoli",
  "Select stage": "Selezionarea fase",
  "date-placeholder": "dd/mm/aaaa",
  "file-name": "Nome del file",
  "uploaded-at": "Caricato presso",
  "accepted-plural": "Accettati",
  "items_plural": "Articoli",
  "You": "Tu",
  "changed": "modificato",
  "you-have-changed-field-to-new": "hai {verb} {field} a {value}|{name} hai {verb} {field} a {value}|{name} ha {verb} {field} a {value}",
  "set": "stabilito",
  "and": "e",
  "Workflow Stage": "Fase",
  "Order Item": "Articolo",
  "length": "lunghezza",
  "lengthUnits": "Unità di lunghezza",
  "position": "posizione",
  "workflow-stage": "fase",
  "history-position": "la posizione",
  "history-status": "lo stato",
  "Accepted": "Accettato",
  "history-width": "la larghezza",
  "history-quantity": "la quantità",
  "history-widthUnits": "le unità di larghezza",
  "history-lengthUnits": "le unità di lunghezza",
  "history-length": "la lunghezza",
  "history-description": "la descrizione",
  "email-address": "Indirizzo e-mail",
  "we-have-detected-that-you-dont-belong-to-any-company": "Abbiamo rilevato che non fai parte di nessuna azienda, puoi crearne una nuova o chiedere all'amministratore di un'azienda di invitarti.",
  "create-new-company": "Creare una nuova azienda",
  "Reason for rejection": "Motivo del rifiuto",
  "Error downloading file": "Errore durante il download del file",
  "Partner": "Partner",
  "Partner Material SKU": "SKU del partner",
  "material-name-partner": "Nome materiale del partner",
  "Deleted": "Soppresso",
  "MaterialType has materials associated with it": {},
  "Cannot delete this Material Type because it has materials associated with it": "Non è possibile eliminare questo tipo di materiale perché ha dei materiali associati.",
  "Cannot delete this Material because it has order items associated with it": "Non è possibile eliminare questo Materiale perché vi sono associati degli articoli d'ordine.",
  "select-your-company": "Seleziona la tua azienda",
  "we-have-detected-that-you-belong-to-more-than-one-company-please-choose-the-company-you-wish-to-log-in-with": "Abbiamo rilevato che lei appartiene a più di un'azienda. Si prega di scegliere la società con cui si desidera accedere.",
  "Material already exists with": "Il materiale esiste già con",
  "Sort order": "Ordinamento",
  "Sort by": "Ordina per",
  "Any": "Qualsiasi",
  "Order items moved to stage": "Ordini spostati sul palco",
  "Role is required": "Il ruolo è richiesto",
  "units-are-required": "Le unità sono richieste",
  "Select partner": "Selezionare partner",
  "select-sorting-method": "Selezionare metodo di ordinamento",
  "Encrypted": "Crittografato",
  "Outgoing Orders": "Ordini in uscita",
  "Job": "Lavoro",
  "Encrypt jobs": "Crittografare i lavori",
  "Encrypt outgoing jobs before sending them to your partner": "Crittografia dei lavori in uscita prima di inviarli al partner",
  "Send the item file as it is": "Inviare il file dell'articolo così com'è",
  "Send ": {
    "xjb jobs instead of files": "Invio di lavori .xjb invece che di file"
  },
  "Third Party Licenses": "Licenze di terze parti",
  "resolution-x": "Risoluzione X",
  "resolution-y": "Risoluzione Y",
  "Height": "Altezza",
  "Profile": "Profilo",
  "num-channels": "Num. canali",
  "num-colorways": "Num. Colori",
  "No image file. Please request the partner to upload the image again.": "Nessun file immagine. Richiedi al partner di caricare nuovamente l'immagine.",
  "file_size_exceeded": "Il file {nome} supera il limite di dimensione di {size} MB",
  "file_type_not_allowed": "Tipo di file \"{type}\" non consentito",
  "There is no maximum": "Non esiste un massimo",
  "All the extensions": "Tutte le estensioni",
  "Configuration": "Configurazione",
  "Allowed file extensions": "Estensioni di file consentite",
  "maximum-file-size-in-megabytes-mb": "Dimensione massima del file in megabyte (MB)",
  "configuration-updated": "Configurazione aggiornata",
  "error-updating-configuration": "Errore durante l'aggiornamento della configurazione",
  "Manage services": "Gestire i servizi",
  "Ratings": "Recensioni",
  "Reviews": "Recensioni",
  "Third-party licenses": "Licenze di terze parti",
  "third-party-licenses-description": "Ciao a tutti! \nVolevamo solo farvi sapere che stiamo utilizzando alcune librerie e strumenti di terze parti per aiutarci a sviluppare il nostro software. Queste licenze open-source sono state di grande aiuto per rendere il nostro progetto più efficiente ed efficace. Siamo molto grati per il duro lavoro e la dedizione degli sviluppatori che hanno creato questi strumenti e siamo entusiasti di continuare a usarli per rendere il nostro progetto ancora migliore!",
  "third-party-software-that-is-part-of-the-web-application": "Software di terze parti che fa parte dell'applicazione web:",
  "file-too-large": "Dimensione file non valida. La dimensione del file deve essere inferiore a {maxSize} MB.",
  "Primary": "Primario",
  "Surface": "Superficie",
  "Encrypted in the partner": "Crittografato nel partner",
  "Pending information": "Informazioni in sospeso",
  "Table": "Tabella",
  "Compact cards": "Schede compatte",
  "Full sized cards": "Carte a grandezza naturale",
  "Custom Fields": "Campi personalizzati",
  "Custom Dialogs": "Finestre di dialogo personalizzate",
  "add-custom-field": "Aggiungere un campo personalizzato",
  "field-type": "Tipo di campo",
  "text": "testo",
  "Label": "Etichetta",
  "Text": "Testo",
  "Boolean": "Booleano",
  "Options": "Opzioni",
  "insert-field-available-options": "Scrivi e premi 'Invio' per aggiungere ogni opzione",
  "custom-field-deleted": "Campo personalizzato eliminato",
  "error-deleting-custom-field": "Errore durante l'eliminazione del campo personalizzato",
  "Multiselect": "Multiselezione",
  "Dropdown": "A discesa",
  "default-value": "Valore predefinito",
  "manage-custom-dialogs": "Gestione delle finestre di dialogo personalizzate",
  "add-custom-dialog": "Aggiungere una finestra di dialogo personalizzata",
  "dialog-title": "Titolo della finestra di dialogo",
  "Title": "Titolo",
  "this-title-will-be-shown-on-the-dialog-header": "Questo titolo verrà visualizzato nell'intestazione della finestra di dialogo.",
  "No Status": "Nessuno stato",
  "No Material": "Nessun materiale",
  "remove-all-filters": "Rimuovere tutti i filtri",
  "do-you-want-to-delete-this-item": "Volete cancellare questa voce?",
  "Fields": "Campi",
  "Required": "Richiesto",
  "Read only": "Solo lettura",
  "TextArea": "Area di testo",
  "delete-question": "Cancellare?",
  "this-cant-be-undone": "Questa modifica non può essere annullata",
  "add-new-filed": "Aggiungere un nuovo file",
  "select-a-field": "Selezionare campo",
  "Custom fields": "Campi personalizzati",
  "Entity": "Entità",
  "order-new-custom-field": "ordine-nuovo-campo-cliente",
  "new-custom-field": "Nuovo campo personalizzato",
  "New Custom Field": "Nuovo campo personalizzato",
  "custom-field-saved": "Campo personalizzato salvato con successo",
  "custom-dialog-saved": "Finestra di dialogo personalizzata salvata",
  "custom-dialog-save-error": "Errore nel salvataggio della finestra di dialogo personalizzata",
  "Custom field saved": "Campo personalizzato salvato",
  "error-saving-custom-field": "Errore nel salvataggio del campo personalizzato",
  "Su": "Do",
  "Mo": "Lu",
  "Tu": "Ma",
  "We": "Me",
  "Th": "Gi",
  "Fr": "Ve",
  "Sa": "Sa",
  "January": "Gennaio",
  "February": "Febbraio",
  "March": "Marzo",
  "April": "Aprile",
  "May": "Maggio",
  "June": "Giugno",
  "July": "Luglio",
  "August": "Agosto",
  "September": "Settembre",
  "October": "Ottobre",
  "November": "Novembre",
  "December": "Dicembre",
  "error-deleting-users": "Errore nell'eliminazione dell'utente|Errore nell'eliminazione dell'utente",
  "or-login": "O Accedi",
  "project": "Progetto",
  "about-us": "Chi siamo",
  "no-available-options": "Nessuna opzione disponibile",
  "user-created-successfully": "Utente creato con successo",
  "Rejected": "Rifiutato",
  "Disable job": "Lavoro disabilitato",
  "Print end": "Stampa finita",
  "Print End": "Stampa Terminato",
  "error-deleting": "Errore nell'eliminazione",
  "deleted-successfully": "Eliminato con successo",
  "Filter": "Filtro",
  "Ascending": "Ascendente",
  "Descending": "Discendente",
  "select-order": "Seleziona l'ordine",
  "show-expired": "Mostra scaduto",
  "show-expired-files": "Mostra file scaduti",
  "error-resetting-custom-dialog": "Si è verificato un errore durante la reimpostazione della finestra di dialogo personalizzata",
  "custom-dialog-has-values": "Sono presenti valori impostati per i campi personalizzati di questa finestra di dialogo",
  "together": "insieme",
  "lets-print": "Stampiamo {0}!",
  "apply-to-all": "Applica a tutti",
  "Catalan": "Catalano",
  "Spanish": "Spagnolo",
  "English": "Inglese",
  "Italian": "Italiano",
  "search-by-material": "Cerca per materiale",
  "no-materials-found": "Nessun materiale trovato",
  "data-use-policy": "Politica sull'utilizzo dei dati",
  "cookies-use": "Utilizzo dei cookie",
  "drop-files-here-to-create-a-new-order": "Trascina i file qui per creare un nuovo ordine",
  "drop-files-here": "Trascina i file qui",
  "drop-files-here-default-order": "Trascina i file qui per un ordine predefinito",
  "Show less": "Mostra meno",
  "Show more": "Mostra di più",
  "No information available": "Nessuna informazione disponibile",
  "Page height": "Altezza della pagina",
  "Page width": "Larghezza della pagina",
  "order-item-moved-to-stage-name-successfully": "L'articolo è stato spostato correttamente nella fase \"{name}\"",
  "send-it-again": "inviarlo di nuovo",
  "Move to workflow": "Passare al flusso di lavoro",
  "Sunday": "Domenica",
  "Monday": "Lunedi",
  "Tuesday": "Martedì",
  "Wednesday": "Mercoledì",
  "Thursday": "Giovedì",
  "Friday": "Venerdì",
  "Saturday": "Sabato",
  "Sun": "Dom",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mer",
  "Thu": "Gio",
  "Fri": "Ven",
  "Sat": "Sab",
  "Jan": "Gen",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "Jun": "Giu",
  "Jul": "Lug",
  "Aug": "Ago",
  "Sep": "Set",
  "Oct": "Ott",
  "Nov": "Nov",
  "Dec": "Dic",
  "add-order-type": "Aggiungi tipo di ordine",
  "order-type-stage": "Fase predefinita",
  "are-you-sure": "Sei sicuro?",
  "delete-order-type": "Elimina il tipo di ordine",
  "are-you-sure-you-want-to-delete-this-order-type": "Sei sicuro di voler eliminare questo tipo di ordine?",
  "you-have-unsaved-changes-if-you-leave-now-you-may-lose-yor-changes-are-you-sure-you-want-to-leave": "Hai cambiati cambiamenti. \nSe parti ora potresti perdere le tue modifiche, sei sicuro di voler andartene?",
  "Order Type": "Tipo d'ordine",
  "commmunity-platform": "piattaforma comunitaria",
  "between-designers": "tra designer",
  "printer-mills": "stamperias",
  "follow-us": "Seguici",
  "centrilized-hub": "hub centrilizzato",
  "collaboration-communication-and-creativity": "collaborazione, comunicazione e creatività",
  "id": "Id",
  "order": "Ordine",
  "UpdatedAt": "Aggiornamento",
  "CurrentFile": "File corrente",
  "OrderId": "Ordine ID",
  "Line": "Linea",
  "WorkflowStageId": "ID stadio del flusso di lavoro",
  "ParentId": "ID ordine genitore",
  "CurrentFileId": "ID file corrente",
  "Position": "Posizione",
  "Order Types": "Tipi di ordine",
  "manage-company-and-services-in-administration": "Gestisci azienda e servizi in amministrazione",
  "manage-orders-in-workflows-view": "Gestisci gli ordini nella visualizzazione dei flussi di lavoro",
  "manage-roles-and-permissions-in-administration": "Gestisci \"ruoli e autorizzazioni\" in amministrazione",
  "manage-materials-in-administration": "Gestisci materiali in amministrazione",
  "manage-users-in-administration": "Gestisci gli utenti in amministrazione",
  "manage-workflows-in-administration": "Gestisci flussi di lavoro in amministrazione",
  "manage-partners-in-administration-also-manage-partners-in-partners-discovery": "Gestire i partner in amministrazione. \nGestisci anche i partner in partner Discovery",
  "manage-activity-history-of-the-orders-in-workflows-view": "Gestisci la cronologia delle attività degli ordini nella vista dei flussi di lavoro",
  "information-not-available-for-this-entity": "Informazioni non disponibili per questa entità",
  "Checkbox": "Casella di controllo",
  "Repetitions": "Ripetizioni",
  "propagate-units-to-all-items": "Propagare unità a tutti gli articoli",
  "default-workflow-stage-for-incoming-orders-cant-be-a-partners-stage": "La fase di flusso di lavoro predefinito per gli ordini in arrivo non può essere una fase di \"partner\"",
  "Developers": "Sviluppatori",
  "layouts": "Layouts",
  "no-layouts-found": "Nessun layout trovato",
  "new-layout": "Nuovo Layout",
  "layout-name-placeholder": "Nuovo layout",
  "choose-file": "Scegli il file",
  "upload-layout-file": "Carica file di layout",
  "upload-layouts-individually-in-bulk-or-as-a-zip-archive-any-files-with-matching-names-will-be-automatically-updated-with-your-new-versions": "Carica layout singolarmente o in blocco. \nTutti i file con nomi corrispondenti verranno aggiornati automaticamente con le tue nuove versioni.",
  "Upload files": "Carica file",
  "Upload": "Caricamento",
  "Preparing files": "Preparazione di file",
  "Error": "Errore",
  "default-layout": "Layout predefinito",
  "default-layout-description": "Questo layout verrà applicato all'ordine durante la creazione del file di lavoro",
  "Layout": "Disposizione",
  "Layout applied": "Disposizione applicata",
  "Layout selected": "Layout selezionato",
  "Number of pages": "Numero di pagine",
  "number-of-inputs": "Numero di immagini",
  "allowed-users": "Utenti consentiti",
  "Visible": "Visibile",
  "layout-updated-successfully": "Layout aggiornato correttamente",
  "attachments": "Attachments",
  "show-attachments": "Mostra attaccamenti",
  "layout-cant-be-changed-after-the-order-has-been-created": "Il layout non può essere modificato dopo che l'ordine è stato creato",
  "error-accepting-order": "Errore che accetta l'ordine",
  "order-type-cant-be-changed-after-the-order-has-been-created": "Il tipo di ordine non può essere modificato dopo aver creato l'ordine",
  "Layouts": "Layouts",
  "users-and-access": "Utenti e accesso",
  "Organization": "Organizzazione",
  "system-configuration": "Configurazione del sistema",
  "workflow-&-orders": "Flusso di lavoro e ordini",
  "Resources": "Risorse",
  "error-saving-the-stage": "Errore nel salvataggio della fase",
  "stage-saved-successfully": "Scena salvata con successo",
  "Workflow already exists with same name": "Il flusso di lavoro esiste già con lo stesso nome",
  "Already partners": "È già partner",
  "verification-email-sent": "Email di verifica inviata",
  "verification-email-description": "Si prega di controllare la tua casella di posta e fare clic sul link di verifica per attivare il tuo account. Questo passaggio è necessario per completare la tua registrazione e accedere a tutte le funzionalità.",
  "mail_not_received_verification": "Non hai ricevuto l'email? Controlla la tua cartella spam.",
  "user-account-not-verified": "Account utente non verificato",
  "sorry-this-user-email-has-not-been-verified-please-check-your-inbox-for-the-verification-email": "Siamo spiacenti, l'email di questo utente non è stata verificata. Per favore, controlla la tua casella di posta per l'email di verifica.",
  "company-is-not-active": "L'azienda non è attiva",
  "sorry-the-company-you-are-trying-to-access-is-not-active-please-contact-your-company-administrator": "Siamo spiacenti, l'azienda a cui stai tentando di accedere non è attiva. Attendi fino a quando il nostro team di vendita convalida questo account.",
  "default-workflow-description": "Quando crei un ordine, verrà inserito automaticamente in questo flusso di lavoro",
  "Optimize jobs": "Ottimizza lavori",
  "some-file-types-are-not-compatible-with-layouts": "Alcuni tipi di file non sono compatibili con i layout",
  "supported-file-types-are": "I tipi di file supportati sono",
  "file-type-is-not-supported-in-layouts": "Il tipo di file non è supportato nei layout",
  "failed-to-delete-order-items": "Impossibile eliminare gli articoli dell'ordine",
  "cant-delete-item-because-it-has-children": "Non è possibile eliminare l'elemento perché è stato accettato da un partner",
  "selected-items": "articoli selezionati",
  "an-order-with-status-accepted-cannot-be-moved": "Un ordine con stato \"Accettato\" non può essere spostato",
  "Cannot do this action because at least one item it has been sent to a partner": "Impossibile eseguire questa azione perché è stato inviato almeno un ordine a un partner",
  "there-was-an-error-loading-the-order-items": "Si è verificato un errore durante il caricamento degli articoli dell'ordine.",
  "Created by": "Creato da",
  "Created By": "Creato da",
  "Customers": "Clienti",
  "Phone": "Telefono",
  "new-customer": "Nuovo cliente",
  "are-you-sure-you-want-to-delete-this-customer": "Sei sicuro di voler eliminare questo cliente?",
  "customer-deleted-successfully": "Cliente eliminato con successo",
  "send-a-webhook-to-specified-url": "Invia un webhook all'URL specificato",
  "send-webhook": "Invia webhook",
  "enter-webhook-url": "Inserisci l'URL del webhook",
  "Webhook sent": "Webhook inviato",
  "Error sending webhook": "Errore nell'invio del webhook",
  "Request failed with status code 404": "La richiesta è fallita con codice di stato 404: Non trovato",
  "webhook-url-is-required": "L'URL del webhook è richiesto",
  "pre-process-layout": "Pre-elaborazione del layout",
  "pre-process-layout-description": "Se selezionato, il modello verrà pre-elaborato nel cloud per generare un lavoro prima di inviarlo alla stampa. Se non selezionato, il modello verrà applicato dopo che è stato inviato alla stampante.",
  "Printer": "Stampante",
  "Scheme": "Schema",
  "Print automatically": "Stampa auto",
  "search-by-customer": "Ricerca per cliente",
  "search-by-layout": "Cerca per layout",
  "search-by-scheme": "Ricerca per schema",
  "search-by-printer": "Ricerca per stampante",
  "item": "Articolo",
  "select-printer": "Seleziona stampante",
  "select-scheme": "Seleziona schema",
  "pages": "pagina|pagine",
  "images": "immagine|immagini",
  "removed": "rimosso",
  "removed-field": " rimosso {field}|{name} ha rimosso {field}|{name} ha rimosso {field}",
  "status": "stato",
  "Batch created successfully": "Il batch {batchNumber} è stato creato correttamente",
  "Failed to create batch": "Impossibile creare il batch",
  "Cannot create batch with items that already belong to another batch": "Impossibile creare un batch con elementi che già appartengono a un altro batch",
  "Create a batch": "Crea un batch",
  "Manage batch": "Gestisci batch",
  "Cannot mix items with and without batch. Select only items without batch to create, or only items with batch to manage.": "Non è possibile mescolare elementi con e senza batch. Seleziona solo elementi senza batch per creare, o solo elementi con batch per gestire.",
  "Create a new batch with selected items": "Crea un nuovo batch con gli elementi selezionati",
  "Add selected items to an existing batch": "Aggiungi elementi selezionati a un batch esistente",
  "Remove selected items from their batches": "Rimuovi elementi dai loro batch",
  "Remove from batch {batchNumber}": "Rimuovi dal batch {batchNumber}",
  "Remove from batches {batchNumbers}": "Rimuovi dai batch {batchNumbers}",
  "No items without batch to create batch": "Nessun elemento senza batch per creare batch",
  "No items without batch to add": "Nessun elemento senza batch da aggiungere",
  "No items with batch to remove": "Nessun elemento con batch da rimuovere",
  "Items added to batch successfully": "Elementi aggiunti al batch con successo",
  "Items removed from batch successfully": "Elementi rimossi dal batch con successo",
  "Failed to manage batch": "Impossibile gestire il batch",
  "No batch selected": "Nessun batch selezionato",
  "Items from different batches": "Elementi da batch diversi",
  "Batches: {batchNumbers}": "Batch: {batchNumbers}",
  "Selected items belong to different batches. They will be removed from their current batches.": "Gli elementi selezionati appartengono a batch diversi. Verranno rimossi dai loro batch attuali.",
  "the batch number": "il numero di lotto",
  "Next batch number": "Numero di lotto successivo",
  "Last batch created": "Ultimo lotto creato",
  "Must be greater than": "Deve essere maggiore di",
  "edit-n-items": "Modifica {n} elementi",
  "edit-n-jobs": "Modifica {n} lavori",
  "width-units": "Unità di larghezza",
  "Multiple": "Multipli",
  "none": "Nessuno",
  "MULTIPLE_VALUES_INDICATOR": "Multipli",
  "there-was-an-error-editing-the-order-items": "Si è verificato un errore durante la modifica degli articoli dell'ordine",
  "order-items-updated-successfully": "Elementi aggiornati con successo",
  "search-by-email": "Cerca per email",
  "search-by-phone": "Cerca per telefono",
  "search-by-state": "Ricerca per stato",
  "print_progress": "Progresso della stampa",
  "search-by-zip": "Cerca per codice postale",
  "search-by-address": "Cerca per indirizzo",
  "Disable_job": "Disabilita lavoro",
  "Do you want to split this ítem? A new order with _split suffix will be created": "",
  "Error while archiving order ítem": "",
  "Order ítem archived successfully": "",
  "Order ítem has been archived": "",
  "Partner Mat": {
    " SKU": "Partner"
  },
  "Preprocess layout": "Layout di preelaborazione",
  "There was an error moving the ítem": "",
  "USER": "Utente",
  "back-to-login": "Torna al login",
  "cant-delete-ítem-because-it-has-been-sent-to-a-partner": "",
  "created this order ítem": "",
  "disable_job": "Disabilita lavoro",
  "enable_job": "Abilita lavoro",
  "print_start": "Inizio stampa",
  "hey-there-just-wanted-to-let-you-know-that-weve-been-using-some-awesome-third-party-libraries-and-tools-to-help-us-develop-our-software-these-open-source-licenses-have-been-a-huge-help-in-making-our-project-more-efficient-and-effective-were-super-grateful-for-the-hard-work-and-dedication-of-the-developers-who-created-these-tools-and-were-excited-to-keep-using-them-to-make-our-project-even-better": "Ciao! Volevo solo farti sapere che abbiamo utilizzato alcune fantastiche librerie e strumenti di terze parti per aiutarci a sviluppare il nostro software. Queste licenze open-source sono state di grande aiuto nel rendere il nostro progetto più efficiente ed efficace. Siamo super grati per l'impegno e la dedizione degli sviluppatori che hanno creato questi strumenti, e siamo entusiasti di continuare ad usarli per migliorare ancora di più il nostro progetto!",
  "in-queue": "In coda",
  "internal-use-field": "Campo di utilizzo interno, non può essere modificato",
  "search-by-city": "Ricerca per città",
  "search-by-country": "Ricerca per paese",
  "select-date": "Seleziona data",
  "select-material": "Seleziona materiale",
  "there-was-an-error-deleting-the-ítem": "",
  "there-was-an-error-downloading-the-file": "Si è verificato un errore durante il download del file",
  "there-was-an-error-fetching-the-layouts": "Si è verificato un errore nel recupero dei layout",
  "View all": "Vedi tutto",
  "by-material": "Per materiale",
  "by-due-date": "Per data di scadenza",
  "by-creation-date": "Per data de creazione",
  "by-batch": "Per lotto",
  "by-customer": "Dal cliente",
  "by-order-type": "Per tipo di ordine",
  "Buckets": "Gruppi",
  "Batch": "Lotto",
  "By": "Da",
  "customer": "cliente",
  "orderType": "tipo di ordine",
  "date": "data",
  "creationDate": "data di creazione",
  "without-material": "Senza materiale",
  "search-by-order-type": "Ricerca per tipo di ordine",
  "Without": "Senza",
  "this-week": "Questa settimana",
  "old": "Scaduto",
  "rest": "Futuro",
  "batch": "lotto",
  "no-due-date": "Senza data di scadenza",
  "next-week": "La prossima settimana",
  "tomorrow": "Domani",
  "Search by batch": "Cerca per lotto",
  "selected-n-length": "{n} {units} selezionate",
  "Cards": "Carte",
  "List": "Elenco",
  "total-items": "Articoli totali",
  "total-length": "Lunghezza totale",
  "quantity": "quantità",
  "the quantity": "la quantità",
  "the width": "la larghezza",
  "the length": "la lunghezza",
  "the widthUnits": "le unità di larghezza",
  "the lengthUnits": "le unità di lunghezza",
  "the material": "il materiale",
  "the workflowStage": "la fase del flusso di lavoro",
  "the printer": "la stampante",
  "the scheme": "lo schema",
  "the layout": "il layout",
  "There are no schemes configured for this printer": "Non sono presenti schemi configurati per questa stampante",
  "Uploads": "Caricamenti",
  "Clear all": "Cancella tutto",
  "No uploads": "Nessun caricamento",
  "Some order items already have a batch": "Alcuni elementi del secchio appartengono già a un lotto",
  "create-a-batch-with-n-elements-for-this-bucket": "Creare un lotto con {n} elemento per questo secchio?|Creare un lotto con {n} elementi per questo secchio?",
  "Path": "Ruta",
  "Select layout": "Seleziona un layout",
  "Select customer": "Seleziona un cliente",
  "select-a-user": "Seleziona un utente",
  "Order ID": "ID Ordine",
  "Item ID": "ID Item",
  "download-pdf": "Scarica PDF",
  "Split PDF": "Dividi PDF",
  "pdf-has-n-pages-split-question": "Il PDF \"{name}\" ha {count} pagine. Vuoi dividere ogni pagina in un articolo separato?",
  "Split into separate items": "Dividi in articoli separati",
  "Keep as single item": "Mantieni come singolo articolo",
  "Select pages to import": "Seleziona pagine da importare",
  "Grid view": "Vista griglia",
  "List view": "Vista elenco",
  "n-pages-selected": "{count} di {total} pagine selezionate|{count} di {total} pagine selezionate",
  "Import": "Importa",
  "Loading previews...": "Caricamento anteprime...",
  "Connected Devices": "Dispositivi connessi",
  "connect-with-qr-reader": "Connettiti con il lettore QR",
  "2-open-the-app-go-to-setting-click-on-add-button-and-scan-the-qr-code": "2. Apri l'app, vai su Impostazioni, fai clic sul pulsante \"+\" e scansiona il codice QR",
  "1-download-the-qr-reader-app": "1. Scarica l'app QR Reader",
  "move-to-next-stage": "Sposta alla fase successiva",
  "view-order": "Visualizza ordine",
  "view-batch": "Visualizza lotto",
  "the currentFile": "il file",
  "destination": "Destinazione",
  "printer": "Stampante",
  "Website": "Sito web",
  "Social Networks": "Reti sociali",
  "Choose platform": "Scegli la piattaforma",
  "Choose a platform": "Scegli una piattaforma",
  "URL completa": "URL completo",
  "Network name": "Nome della rete",
  "Link with user": "Collegamento/{'@'}utente",
  "View website": "Visualizza la pagina web",
  "Other social network": "Altro social network",
  "No social networks added": "Nessun social network aggiunto",
  "Add social network": "Aggiungi rete sociale",
  "yourusername": "tuoutente",
  "edit-1-item": "Modifica 1 elemento",
  "Export": "Esportare",
  "change-action": "Cambia azione",
  "multiple-values": "Valori multipli",
  "Printer-updated-successfully": "Stampante aggiornata correttamente",
  "There-was-an-error-updating-the-layout": "Si è verificato un errore che aggiorna il layout",
  "There-was-an-error-updating-the-printer": "Si è verificato un errore durante l'aggiornamento della stampante",
  "Are-you-sure-delete-printers": "Sei sicuro di voler eliminare le stampanti selezionate?",
  "Are-you-sure-delete-printer": "Sei sicuro di voler eliminare la stampante selezionata?",
  "Printers deleted successfully": "Stampanti eliminate correttamente",
  "There-was-an-error-deleting-the-printers": "Si è verificato un errore durante l'eliminazione delle stampanti",
  "Materials deleted successfully": "Materiali eliminati con successo",
  "There-was-an-error-deleting-the-materials": "Si è verificato un errore durante l'eliminazione dei materiali",
  "Are-you-sure-delete-material": "Sei sicuro di voler eliminare il materiale selezionato?",
  "Are-you-sure-delete-materials": "Sei sicuro di voler eliminare i materiali selezionati?",
  "Loading layouts data": {
    " Please wait": "Caricamento dei dati dei layout. \nattendere prego"
  },
  "Connect-your-device-to-scan-QR": "Collega il tuo dispositivo per scansionare i codici QR dai PDF e vai direttamente alla pagina delle azioni dell'articolo.",
  "Files": "File",
  "Batches": "Lotti",
  "Export PDF": "Esporta PDF",
  "end-date": "Data di fine",
  "aborted-date": "Data de aborto",
  "Done Items": "Elementi completati",
  "jobs": "lavoro|lavori",
  "send-to-printer": "Invia alla stampante",
  "move-to-printer": "Sposta alla stampante",
  "Print Jobs": "Lavori di stampa",
  "Update Date": "Data di aggiornamento",
  "select-order-type": "Seleziona il tipo di ordine",
  "select-batch": "Seleziona lotto",
  "search-by-batch": "Cerca per lotto",
  "cannot-edit-layout-when-in-printers-or-done-stage": "Impossibile modificare il layout nelle fasi di tipo 'Stampanti' o 'Fatto'",
  "cannot-edit-scheme-when-in-printers-or-done-stage": "Impossibile modificare lo schema nella fasi di tipo 'Stampanti' o 'Fatto'",
  "cannot-edit-printer-when-in-printers-or-done-stage": "Impossibile modificare la stampante nella fasi di tipo 'Stampanti' o 'Fatto'",
  "Cannot save with a hidden printer": "Impossibile salvare quando la fase è di tipo 'Stampanti' e la stampante selezionata non è visibile",
  "column-order-not-configured-yet": "L'ordine delle colonne non è stato ancora configurato in 'Configurazione'",
  "Reset Order": "Reimposta ordine",
  "Order Columns": "Ordina colonne",
  "Default column order and visibility": "Ordine e visibilità delle colonne predefiniti",
  "Configure Columns": "Configura colonne",
  "Configure default column order": "Configura l'ordine delle colonne predefinito",
  "Default Column Order": "Ordine delle colonne predefinito",
  "Reorder Columns": "Riordina colonne",
  "at-least-one-of-the-selected-items-is-currently-in-the-printers-stage-the-attached-print-job-will-be-cancelled-are-you-sure-you-want-to-move-it-out-of-that-stage": "L'elemento selezionato è attualmente nella fase Stampanti. Il lavoro di stampa allegato verrà annullato se non è ancora iniziato. Vuoi spostarlo fuori dallo stage?|Almeno uno degli elementi selezionati è attualmente nello stage Stampanti. I lavori di stampa allegati verranno annullati se non sono ancora iniziati. Sei sicuro di volerli spostare fuori dal palco?",
  "confirm-removing-from-printers-stage": "Conferma la rimozione dalla fase Stampanti",
  "at-least-one-of-the-selected-items-has-already-been-printed-are-you-sure-you-want-to-move-it-back-to-the-printers-stage": "L'elemento selezionato è già stato stampato in precedenza. Sei sicuro di volerlo spostare nuovamente nella fase Stampanti?|Almeno uno degli elementi selezionati è già stato stampato in precedenza. Sei sicuro di volerli spostare nuovamente nella fase Stampanti?",
  "confirm-moving-to-printers-stage": "Conferma lo spostamento alla fase Stampanti",
  "yes-move-it": "Sì, spostalo",
  "no-keep-it": "No, tienilo",
  "the-selected-item-is-currently-in-the-printers-stage": "L'elemento selezionato è attualmente nella fase Stampanti.|Almeno uno degli elementi selezionati è attualmente nella fase Stampanti.",
  "Default printer": "Stampante predefinita",
  "Default scheme": "Schema predefinito",
  "API Tokens & Devices": "Token e dispositivi API",
  "Starting batch number": "Numero di lotto iniziale (il lotto successivo sarà questo numero)",
  "Configure which columns are visible and their default order": "Configura quali colonne sono visibili e il loro ordine predefinito. \nQueste impostazioni verranno utilizzate come valori di ripristino per tutti gli utenti.",
  "No tokens yet": "Nessun token ancora",
  "A token with this name already exists": "Esiste già un token con questo nome, scegli un nome diverso",
  "Error generating token": "Errore durante la generazione del token",
  "Enter your token name": "Inserisci il nome del tuo token",
  "Generate a new token": "Genera un nuovo token",
  "archive": "Archiviare",
  "cancel-jobs": "Annulla",
  "cancel-print-jobs": "Annulla lavoro di stampa|Annulla lavori di stampa",
  "cancel-print-job-disabled": "È possibile annullare solo lavori con lo stato \"In sospeso\" o \"Assegnato\"",
  "reason-for-cancelling": "Motivo dell'annullamento",
  "enter-reason-for-cancelling": "Inserisci un motivo per annullare il lavoro di stampa|Inserisci un motivo per annullare i lavori di stampa",
  "do-you-want-to-cancel-these-print-jobs": "Vuoi annullare questo lavoro di stampa?|Vuoi annullare questi lavori di stampa?",
  "cancel-print-job-printer-queue-warning": "L'annullamento di un lavoro di stampa in questo stato cambierà solo il suo stato in ANNULLATO in Inèdit Connect. Non lo annullerà nella coda di stampa. Se il lavoro è ancora nella stampante, dovrai rimuoverlo manualmente dalla stampante.",
  "i-understand-cancel-print-job-printer-queue-warning": "Capisco che potrei dover rimuovere manualmente questo lavoro dalla coda della stampante.",
  "print-jobs-cancelled-successfully": "Lavoro di stampa annullato correttamente|Lavori di stampa annullati correttamente",
  "failed-to-cancel-print-jobs": "Errore durante l'annullamento dei lavori di stampa",
  "unable-to-confirm-cancellation": "Impossibile confermare l'annullamento",
  "cancel-print-job-timeout-warning": "Non è stato possibile confermare l'annullamento nel tempo previsto. È possibile che lo stato del lavoro non sia stato aggiornato nella coda di stampa.",
  "confirm-cancellation-anyway": "Conferma annullamento comunque",
  "print-job-in-printer-queue": "Lavori di stampa nella coda della stampante",
  "print-job-in-printer-queue-message": "Almeno uno dei lavori di stampa selezionati è attualmente nella coda della stampante. L'annullamento verrà inviato al Control Center per l'elaborazione.",
  "jobs-archived-successfully": "Lavori archiviati con successo",
  "error-while-archiving-jobs": "Errore durante l'archiviazione dei lavori",
  "Drag to reorder and toggle visibility as your default": "Trascina per riordinare e attivare la visibilità. \nQuesto ordine verrà utilizzato come ordine di colonna predefinito.",
  "Drag to reorder and toggle visibility as your company": "Trascina per riordinare e attivare la visibilità. \nQuesto diventerà l'impostazione predefinita per tutti gli utenti quando reimposteranno le proprie colonne.",
  "customers": "clienti",
  "printer-queue": "Coda della stampante",
  "unassigned-jobs": "Lavori non assegnati",
  "Order Layout": "Layout",
  "printJobStatus": {
    "PENDING": "In attesa",
    "ASSIGNED": "Assegnato",
    "PROCESSING": "In elaborazione",
    "QUEUED": "In coda",
    "PRINTING": "In stampa",
    "COMPLETED": "Completato",
    "ABORTED": "Annullato",
    "CANCELLED": "Annullato"
  },
  "printJobType": {
    "PRINT": "Stampa",
    "REPRINT": "Ristampa",
    "blankSpace": "Spazio vuoto"
  },
  "Select Control Center": "Seleziona un Control Center",
  "save-and-create-job": "Salva e crea lavoro con layout",
  "No items selected": "Nessun elemento selezionato",
  "are-you-sure-you-want-to-delete-this-comment": "Sei sicuro di voler eliminare questo commento?",
  "Choose a printer": "Scegli una stampante",
  "Choose a scheme": "Scegli uno schema",
  "Download PDF": "Scarica PDF",
  "Error generating the job of the order": "Errore durante la generazione del lavoro dell'ordine",
  "Error generating the job of the order in the partner": "Errore durante la generazione del lavoro dell'ordine nel partner",
  "Failed to load items for PDF": "Impossibile caricare gli elementi per PDF",
  "Go Back": "Torna indietro",
  "Loading ink types data. Please wait": "Caricamento dei dati sui tipi di inchiostro. \nattendere prego",
  "Mail sent": "Mail inviata!",
  "Optimize outgoing jobs before sending them to your partner": "Ottimizza i lavori in uscita prima di inviarli al tuo partner",
  "Order Items": "Articoli",
  "PDF Preview": "Anteprima PDF",
  "reply-with-elipsis": "Rispondere...",
  "Version": "Versione",
  "Wrong URL": "URL errato, riprova o contatta l'amministratore",
  "Exported": "Esportato",
  "item-moved-to-next-stage": "Elemento spostato alla fase successiva",
  "failed-to-move-item-to-next-stage": "Impossibile spostare l'elemento alla fase successiva",
  "Select type": "Seleziona il tipo",
  "export-csv": "Esporta CSV",
  "export-excel": "Esporta Excel",
  "group-by": "Raggruppa per",
  "export-excel-selection-hint": "Esportazione di {n} elemento/i selezionato/i.",
  "export-excel-filters-hint": "Nessuna selezione: verranno esportati gli elementi corrispondenti ai filtri correnti.",
  "export-excel-bucket-hint": "Verranno esportati gli elementi di questo gruppo.",
  "Excel exported successfully": "Excel esportato correttamente",
  "There was an error exporting the Excel": "Si è verificato un errore durante l'esportazione Excel",
  "Print job created successfully": "Lavoro di stampa creato con successo",
  "Failed to create print job": "Impossibile creare il lavoro di stampa",
  "Remove selected printer from jobs": "Rimuovi la stampante selezionata dai lavori",
  "No printer": "Nessuna stampante",
  "Ink consumption": "Consumo di inchiostro",
  "Percentage": "Percentuale",
  "Printed length": "Lunghezza stampata",
  "Print job updated successfully": "Lavoro di stampa aggiornato correttamente",
  "Failed to update print job": "Impossibile aggiornare il lavoro di stampa",
  "Edit print job": "Modifica lavoro di stampa",
  "width-is-required-and-must-be-greater-than-0": "La larghezza è obbligatoria e deve essere maggiore di 0",
  "length-is-required-and-must-be-greater-than-0": "La lunghezza è obbligatoria e deve essere maggiore di 0",
  "Action": "Azione",
  "action": {
    "Nothing": "Nessuna",
    "Queue": "Mettiti in coda",
    "Print": "Mettere in coda e stampare"
  },
  "no-print-jobs": "Nessun lavoro di stampa",
  "quantity-is-required-and-must-be-greater-than-0": "La quantità è obbligatoria e deve essere maggiore di 0",
  "cannot-edit-print-job-in-status-status": "Impossibile modificare il lavoro di stampa nello stato {status}",
  "confirm-remove-from-queue": "Rimuovi dalla coda",
  "confirm-remove-from-queue-message": "Questo lavoro di stampa verrà rimosso dalla coda. Vuoi continuare?",
  "no-orders": "Nessun ordine",
  "action-is-required": "Seleziona un'azione",
  "cant-print-automatically-without-a-printer-and-scheme": "Impossibile stampare automaticamente senza stampante e schema",
  "cant-print-automatically-with-a-printer-type-destination": "Impossibile stampare automaticamente con una stampante di tipo 'Destination'",
  "Print": "Stampa...",
  "Print Jobs History": "Stampa cronologia lavori",
  "New": "Nuovo",
  "no-users-found": "Nessun utente trovato",
  "this-stage-cannot-be-deleted-because-there-are-order-types-using-it": "Questa fase non può essere eliminata perché ci sono tipi di ordine che la utilizzano",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-of-the-workflow": "Questa fase non può essere eliminata perché è impostata come fase predefinita del flusso di lavoro",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-in-some-of-your-partners-preferences": "Questa fase non può essere eliminata perché è impostata come fase predefinita nelle preferenze di alcuni dei tuoi partner",
  "this-stage-cannot-be-deleted-because-it-has-order-items": "Questa fase non può essere eliminata perché ha elementi dell'ordine",
  "move-or-cancel-disabled": "È possibile spostare o annullare solo lavori con lo stato \"In sospeso\" o \"Assegnato\"",
  "the-item-does-not-exist-or-its-an-item-from-another-company": "L'elemento non esiste o appartiene a un'altra azienda",
  "abort": "Interrompi",
  "reason-for-aborting": "Motivo dell'interruzione",
  "enter-reason-for-aborting": "Inserisci un motivo per interrompere il lavoro di stampa",
  "field-is-required": "Questo campo è obbligatorio",
  "field-must-have-at-least-n-characters": "Questo campo deve avere almeno {n} caratteri",
  "print-job-aborted-successfully": "Lavoro di stampa interrotto con successo",
  "Custom field has values and cannot be deleted": "Il campo personalizzato contiene valori e non può essere eliminato",
  "Go back": "Torna indietro",
  "some-image-files-formats-are-not-supported-in-layouts": "Alcuni formati di file non sono supportati nei layout",
  "Download Log": "Scarica i dettagli del lavoro",
  "meters-selected": "metri selezionati",
  "total-meters": "metri totali",
  "New print job": "Nuovo lavoro di stampa",
  "Order Comments": "Commenti sull'ordine",
  "Item Comments": "Commenti sull'elemento",
  "layout-is-not-compatible-with-this-file-extension": "Il layout non è compatibile con questa estensione di file",
  "Printers with print jobs cannot be deleted": "Le stampanti con lavori di stampa non possono essere eliminate",
  "you-dont-have-permission-to-edit-print-jobs": "Non hai il permesso di modificare i lavori di stampa",
  "move-to-stage": "Sposta alla fase {stage}",
  "item-moved-to-stage": "Elemento spostato alla fase {stage}",
  "you-dont-have-permission-to-create-print-jobs": "Non hai il permesso di creare lavori di stampa",
  "the-order-item-is-in-error-status": "L'articolo dell'ordine è in stato di errore",
  "no-printers-stage-configured": "Devi avere una fase con il Tipo \"Printers\" per creare lavori di stampa",
  "Order comments": "Commenti sull'ordine",
  "Item comments": "Commenti sull'elemento",
  "Delivery date": "Data di consegna",
  "Creator": "Creatore",
  "deselect-all": "Deselezionare tutto",
  "ASSIGNED": "ASSEGNATO",
  "CANCELLED": "ANNULLATO",
  "QUEUED": "IN CODA",
  "ABORTED": "FALLITO",
  "PENDING": "IN ATTESA DI",
  "PRINTING": "STAMPA",
  "Abort date": "Data di interruzione",
  "Abort Date": "Data di interruzione",
  "COMPLETED": "COMPLETATO",
  "completed": "Completato",
  "pending": "In attesa",
  "assigned": "Assegnato",
  "processing": "In elaborazione",
  "queued": "In coda",
  "printing": "In stampa",
  "aborted": "Fallito",
  "cancelled": "Annullato",
  "Printed Length": "Lunghezza stampata",
  "Ink Consumption": "Consumo di inchiostro",
  "End Date": "Data finale",
  "Archive Date": "Data di archiviazione",
  "there-was-an-error-with-the-item-size-or-position-please-adjust-the-variables-and-try-again": "Si è verificato un errore con le dimensioni o la posizione dell'elemento. Si prega di regolare le variabili e riprovare.",
  "and-move-to": "e sposta in",
  "PROCESSING": "LAVORAZIONE",
  "Pause": "Pausa",
  "Resume": "Riprendi",
  "Unknown": "Sconosciuto",
  "Offline": "Non in linea",
  "Online": "In linea",
  "Default measurement unit": "Unità di misura predefinita",
  "devices-and-apps": "Dispositivi e app",
  "qr-reader": "Lettore QR",
  "API Tokens": "Token API",
  "connect-with-neocatalog-to-acces-to-all-your-designs-you-will-be-able-to-create-new-orders-using-any-of-your-neocatalog-designs-and-colorways-with-just-a-click": "Connettiti con neoCatalog per accedere a tutti i tuoi design. Potrai creare nuovi ordini utilizzando qualsiasi design e colori di neoCatalog con un solo clic.",
  "connect-with-neocatalog": "Connettiti con neoCatalog",
  "neoCatalog": "neoCatalog",
  "edit-neocatalog-connection": "Modifica connessione neoCatalog",
  "neocatalog-connection-name": "Nome della connessione",
  "neocatalog-api-token": "Token API neoCatalog",
  "neocatalog-api-token-help": "Crea una chiave API permanente in neoCatalog (Amministrazione → Gestione → Utenti → Scegli un utente → API Key) e incollala qui. ",
  "leave-blank-to-keep-current-token": "Lascia vuoto per mantenere il token attuale",
  "neocatalog-connection-created": "neoCatalog connesso correttamente",
  "neocatalog-connection-updated": "Connessione neoCatalog aggiornata",
  "neocatalog-disconnected": "neoCatalog disconnesso",
  "do-you-want-to-disconnect-neocatalog": "Vuoi disconnettere neoCatalog?",
  "Error connecting to neoCatalog": "Errore nella connessione a neoCatalog",
  "Error disconnecting neoCatalog": "Errore nella disconnessione da neoCatalog",
  "Connect": "Connetti",
  "Disconnect": "Disconnetti",
  "Token": "Token",
  "API Token": "Token API",
  "add-from-neocatalog": "Aggiungi da neoCatalog",
  "replace-from-neocatalog": "Sostituisci da neoCatalog",
  "search-designs-by-name-or-code": "Cerca design per nome o codice",
  "search-colorways-by-name-or-code": "Cerca colorway per nome o codice",
  "no-designs-found": "Nessun design trovato",
  "no-colorways-found": "Nessuna colorway trovata",
  "Error loading neoCatalog designs": "Errore nel caricamento dei design neoCatalog",
  "Error loading neoCatalog colorways": "Errore nel caricamento delle colorway neoCatalog",
  "Error downloading neoCatalog file": "Errore nel download del file neoCatalog",
  "Next": "Avanti",
  "Test": "Prova",
  "neocatalog-connection-test-ok": "La connessione a neoCatalog è valida",
  "neocatalog-connection-test-failed": "Il test di connessione a neoCatalog non è riuscito",
  "enter-a-valid-url": "Inserisci un URL valido, incluso http:// o https://. Sono consentiti indirizzi locali come https://hostname.local:2001.",
  "neocatalog-could-not-reach-server": "Impossibile raggiungere neoCatalog a questo URL. Verifica che l'indirizzo sia corretto e che il server sia raggiungibile.",
  "error-replacing-order-item-file-with-neocatalog-file": "Errore nella sostituzione del file dell'articolo con il file neoCatalog",
  "error-adding-order-item-file-with-neocatalog-file": "Errore nell'aggiunta del file dell'articolo con il file neoCatalog",
  "Hide Archived": "Nascondi archiviatos",
  "reset-sort": "Reimposta ordinamento",
  "Move to top": "Sposta in alto",
  "Move up": "Vai su",
  "Move down": "Spostati giù",
  "Move to bottom": "Sposta in basso",
  "reset-sort-to-reorder-manually": "Reimposta ordinamento per riordinare manualmente",
  "only-possible-to-move-jobs-with-status": "È possibile spostare solo lavori con lo stato \"In sospeso\" o \"Assegnato\"",
  "OrderItem": "Articolo",
  "PrintJob": "Lavoro di stampa",
  "Configure Order Items Columns": "Configura colonne degli articoli",
  "Drag to reorder and toggle visibility for order item columns": "Trascina per riordinare e scegliere quali colonne mostrare negli articoli.",
  "order-items-dialog-created": "Finestra di dialogo articoli creata",
  "custom-field": "Personalizzato",
  "select-partner-stage-tooltip": "Seleziona un workflow stage di tipo Partners per abilitare questa opzione",
  "no-partners-available": "Nessun partner disponibile",
  "no-partners-available-tooltip": "Nessun partner disponibile per la tua azienda. Aggiungi partner prima di utilizzare questa funzione.",
  "no-accepted-partners": "Nessun partner accettato",
  "no-pending-invitations": "Nessun invito in sospeso",
  "no-blocked-partners": "Nessun partner bloccato",
  "this-field-is-used-in-a-dialog-and-cannot-be-changed": "Questo campo è utilizzato in una finestra di dialogo e non può essere modificato",
  "total": "totale",
  "selected": "selezionato",
  "History": "Cronologia",
  "material": "Materiale",
  "no-maximum": "Nessun massimo",
  "choose-the-gap-size": "Scegli la dimensione dello spazio",
  "print-blank-space-between-materials-in-batch": "Stampa lo spazio tra i materiali di un lotto",
  "print-blank-space-between-batches": "Stampa lo spazio tra i lotti",
  "force-sequential-jobs-description": "Invia i lavori nell'ordine della coda. Il lavoro successivo attende che il lavoro precedente sulla stessa stampante abbia finito l'elaborazione.",
  "Information": "",
  "add-description": "Aggiungi descrizione...",
  "No preview available": "Nessuna anteprima disponibile",
  "Editing is disabled because item is already accepted": "La modifica è disabilitata perché l'elemento è già stato accettato"
}
